import { render, staticRenderFns } from "./order_bList.vue?vue&type=template&id=290fb9c4&scoped=true"
import script from "./order_bList.vue?vue&type=script&lang=ts"
export * from "./order_bList.vue?vue&type=script&lang=ts"
import style0 from "./order_bList.vue?vue&type=style&index=0&id=290fb9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290fb9c4",
  null
  
)

export default component.exports